import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LoadingState {
  isFullScreenLoading: boolean;
  isSidebarLoading: boolean;
  isTabsLoading: boolean;
  isFieldsLoading: boolean;
  isReportLoading: boolean;
}

const initialState: LoadingState = {
  isFullScreenLoading: false,
  isSidebarLoading: true,
  isTabsLoading: true,
  isFieldsLoading: true,
  isReportLoading: true,
};

const loadingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setIsFullScreenLoading: (state, action: PayloadAction<boolean>) => {
      state.isFullScreenLoading = action.payload;
    },
    setIsSidebarLoading: (state, action: PayloadAction<boolean>) => {
      state.isSidebarLoading = action.payload;
    },
    setIsTabsLoading: (state, action: PayloadAction<boolean>) => {
      state.isTabsLoading = action.payload;
    },
    setIsFieldsLoading: (state, action: PayloadAction<boolean>) => {
      state.isFieldsLoading = action.payload;
    },
    setIsReportLoading: (state, action: PayloadAction<boolean>) => {
      state.isReportLoading = action.payload;
    },
  },
});

export const {
  setIsFullScreenLoading,
  setIsSidebarLoading,
  setIsTabsLoading,
  setIsFieldsLoading,
  setIsReportLoading,
} = loadingSlice.actions;
export default loadingSlice.reducer;
